// src/apiService.js
export async function fetchWithToken(url, options = {}) {
    const serverUrl = 'https://html-creator.demo.cartago.com/'
    let token = localStorage.getItem('accessToken');

    if (!token) {
        const refreshToken = localStorage.getItem('refreshToken');
        if (!refreshToken) {
            window.location.href = '/login'; // Falls beide Tokens fehlen
            return;
        }

        // Versuche, ein neues Access Token zu holen
        const refreshResponse = await fetch('https://html-creator.demo.cartago.com/api/auth/refresh', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ refreshToken }),
        });

        const refreshData = await refreshResponse.json();
        if (!refreshData.accessToken) {
            window.location.href = '/login'; // Falls Refresh fehlschlägt
            return;
        }

        localStorage.setItem('accessToken', refreshData.accessToken);
        token = refreshData.accessToken;
    }

    options.headers = { ...options.headers, Authorization: `Bearer ${token}` };
    return fetch(`${serverUrl}${url}`, options);
}

export function logout(){
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    window.location.reload(); // Nach Logout zur Login-Seite zurückkehren
}
